import type { Routes } from '@angular/router';

import { AuthGuard } from '#core/components/auth/auth.guard';
import { LOGGED_IN_ROUTES } from '#shell/routing/logged-in/logged-in.routes';
import { LOGGED_OUT_ROUTES } from '#shell/routing/logged-out/logged-out.routes';

export const APP_ROUTES: Routes = [
    {
        path: '',
        loadChildren: () => LOGGED_IN_ROUTES,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        providers: [AuthGuard],
    },
    {
        path: '',
        loadChildren: () => LOGGED_OUT_ROUTES,
    },
];
